export default __webpack_public_path__ + "static/media/EMprint Regular.43ecf1e7.eot";